// Number('') is 0, which made an emptied number field snap back to 0 and the
// 0 impossible to erase (SUN-805). Empty or unparseable input maps to null —
// not undefined, which react-hook-form replaces with the field's defaultValue
// mid-edit — so the form value clears instead.
export function parseNumberInputValue(raw: string): number | null {
  if (raw.trim() === "") return null;
  const parsed = Number(raw);
  return Number.isNaN(parsed) ? null : parsed;
}
